export const donationAmount = [
  { id: 1, amount: "50 000 so'm", key: 50000 },
  { id: 2, amount: "100 000 so'm", key: 100000 },
  { id: 3, amount: "150 000 so'm", key: 150000 },
  { id: 4, amount: "200 000 so'm", key: 200000 },
  { id: 5, amount: "Boshqa", key: null },
];
